module.exports = __webpack_public_path__ + "img/home-training-new.6332b2ba.png";